<wms-dialog-header (onClose)="closeModal()" title='{{locale.LABEL_APP_MESSAGES_LANGUAGES_TITLE}}'></wms-dialog-header>
<wms-dialog-body>
    <div class="primary-panel full-width full-height">
        <div class="search-container">
            <wms-search id="addLocale-search" width="18em"
                placeholder="{{locale.LABEL_SEARCH}}"
                (onSearch)="searchLanguage($event)"></wms-search>
        </div>
        <div class="header-container">
            <div class="col-xs-6">
                <label class="app-label">{{locale.LABEL_APP_ADD_LANGUAGES}}</label>
            </div>
            <div class="col-xs-6">
                <label class="app-label">{{locale.LABEL_APP_SELECTED_LANGUAGE}}</label>
            </div>
        </div>
        <div class="locale-container">
            <div class="col-xs-6 full-height">
                <ul class="list-items full-height">
                    <li class="list-item"
                        *ngFor="let map of filteredLocaleCodesMap | keyvalue | filter: 'value': languageSearchKey">
                        <div class="item">
                            <span class="title" title="{{map.value}}">{{map.value}}</span>
                            <button class="float-right btn button-primary btn-sm add-locale-btn add-button"
                                (click)="addLocale(map.key);">
                                <i class="wm-icon wms wms-plus" title="{{locale.LABEL_ADD}}"></i>
                            </button>
                        </div>
                    </li>
                </ul>
            </div>
            <div class="col-xs-6 full-height">
                <ul class="list-items full-height">
                    <li class="list-item" *ngFor="let localeKey of supportedLocale">
                        <div class="item">
                            <span class="title">{{localeCodesMap[localeKey]}}</span>
                            <button class="float-right btn btn-transparent btn-sm add-locale-btn add-button"
                                *ngIf="localeKey !== 'en'" [disabled]="localeKey === projectDefaultLanguage"
                                (click)="deleteLocale(localeKey)">
                                <i class="wm-icon wms wms-delete"
                                    title="{{localeKey === projectDefaultLanguage ?  locale.MESSAGE_ERROR_DELETE_DEFAULT_LANGUAGE_NOT_ALLOWED : locale.LABEL_DELETE}}"></i>
                            </button>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</wms-dialog-body>
<wms-dialog-footer>
    <button (click)="closeModal()" class="btn app-button button-secondary" name="wm-app-message-cancel"
        title="{{locale.LABEL_CANCEL}}">{{locale.LABEL_CANCEL}}</button>
    <button (click)="saveLocale()" class="btn app-button button-primary" title="{{locale.LABEL_SAVE}}"
        name="wm-app-message-save">{{locale.LABEL_SAVE}}</button>
</wms-dialog-footer>